<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Button } from '@/components/ui/button'

const Loader = useIsLoadingStore()
useHead(
    {
      title: 'Contact Us - YourService.ae',
      meta: [
        {
          name: 'description',
          content: 'Get in touch with YourService.ae for any inquiries or support. We are here to assist you with your job search or hiring needs in the UAE.'
        },
        {
          property: 'og:title',
          content: 'Contact Us - YourService.ae'
        },
        {
          property: 'og:description',
          content: 'Get in touch with YourService.ae for any inquiries or support. We are here to assist you with your job search or hiring needs in the UAE.'
        }
      ]
    }
)

const style_contacts_message = {
  width: '540px',
  minHeight: '240px',
  maxHeight: '300px',
  border: 'unset',
  borderRadius: '20px',
  background: 'rgba(246, 248, 250, 1)',
  color: 'rgba(82, 88, 102, 1)'
}


const userEmail = ref('')
const TextareaMessage = ref('')

const formData = ref({
  email: userEmail,
  message: TextareaMessage
});

const MessageSubmit = async (setErrors?: Function) => {
  /*sendFeedback(formData.value).then(() => {
    userEmail.value = ''
    TextareaMessage.value = ''
  }).catch((error) => {
    handleValidationErrors(error, setErrors);
  })*/
};


</script>

<template>
  <div class="container mx-auto px-4 h-screen lg:min-h-[800px]">
    <div class="flex items-center justify-center">
      <div class="grid place-items-center pr-7 pl-7">
        <div class="ys-contacts-logo my-10">
          <p class="ys-home-text ">{{ $t("Get in Touch with Us") }} <br>
            {{ $t("with Any Questions") }}
          </p>
        </div>
        <div class="ys-contacts-body !w-full max-w-[540px]">

          <Input type="email"
                   maxLength="20"
                   v-model="userEmail"
                   class="ys-contacts-input-email !w-full"
                   :placeholder="$t('Your email')"/>
          <Textarea v-model="TextareaMessage"
                      :style="style_contacts_message"
                      class="my-7 ys_contacts_message !w-full"
                      :placeholder="$t('Your message')"
                      :maxlength="600">
          </Textarea>

          <Button :disabled="Loader.isLoading" class="ys-button w-full mb-10" @click="MessageSubmit()">
            <Icon v-if="Loader.isLoading" name="svg-spinners:ring-resize" />
            <span v-else>{{ $t("Send a Message") }}</span>
          </Button>

          <div class="flex items-center justify-center ys-contacts-text space-x-3 flex-wrap">
            <NuxtLink to="https://www.instagram.com/yourservice.ae/profilecard/?igsh=Z3N6dXJpYzRwbTJ6">Instagram</NuxtLink>
            <NuxtLink to="https://www.facebook.com/yourserviceae">Facebook</NuxtLink>
            <NuxtLink to="https://www.linkedin.com/company/yourserviceae/">Linkedin</NuxtLink>
            <NuxtLink to="https://x.com/yourserviceae">X</NuxtLink>
            <NuxtLink to="https://www.youtube.com/@YourService_ae">YouTube</NuxtLink>
            <NuxtLink to="https://www.reddit.com/user/Your-Service/">Reddit</NuxtLink>
            <p class="text-gray-500" style="font-weight: 400">- {{ $t("follow us") }}</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<style scoped lang="scss">
.ys-contacts-logo {
  max-width: 330px;
  width: 100%;
  height: 68px;
}

.ys-contacts-body {
  max-width: 540px;
  width: 100%;
  min-height: 396px;
  @media(max-width: 640px){
    max-width: 320px;
  }
}

.ys-home-text {
  font-family: Involve, sans-serif;
  color: rgba(0, 0, 0, 1);
  font-size: 34px;
  font-weight: 550;
  line-height: 34px;
  text-align: center;
  @media(max-width: 640px){
    font-size: 21px;
  }
}

.ys-contacts-input-email {
  max-width: 540px;
  width:100%;
  height: 56px;
  gap: 0;
  border-radius: 20px;
  background: rgba(246, 248, 250, 1);
  border: unset;
  padding: 0 20px 0 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: -0.36px;
  text-align: left;
  color: rgba(82, 88, 102, 1);

  &:active {
    box-shadow: unset;
  }

  &:hover {
    box-shadow: unset;
  }

  &:focus {
    box-shadow: unset;
  }
}

@media(max-width: 640px){
.custom_width{
  width: 320px !important;
}
}
.ys_contacts_message {
  border: unset;
  max-width: 540px;
  width: 100% !important;
  min-height: 240px;
  max-height: 300px;
  background: rgba(246, 248, 250, 1);
  color: rgba(82, 88, 102, 1);
  @media(max-width: 640px){
    width: 320px !important;
  }
}


.ys-contacts-text {
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: rgba(10, 13, 20, 1);
}

</style>